export default __webpack_public_path__ + "static/media/sidebar-0.47fbda9b.jpg";